module.exports = __webpack_public_path__ + "static/image 109-8a20990a49a4ebc3f7afb31873a59923.png";